import styled, {css} from 'styled-components';

import {directHoverSelector} from '../../../../../libs/shared/helpers/src/browser/hoverHelpers';
import {IconButton} from '../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {center, ellipsis, flexCenter} from '../../../../../libs/shared/ui/src/styles/mixins';
import {TableCellStyleProps} from './tableCell';

export const StyledNameDiv = styled.div`
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.bold};
  ${ellipsis()};
`;

export const StyledDetailsContainerDiv = styled.div`
  grid-area: label;
  overflow: hidden;
  display: grid;
  grid-row-gap: 4px;
  grid-auto-flow: row;
  grid-auto-rows: auto;
  align-items: center;
`;

export const StyledBlurbDiv = styled.div<Pick<TableCellStyleProps, '$isSelected'>>`
  font-size: ${fontSizes.verySmall};
  ${ellipsis()};
  padding-top: 4px;
  &:empty {
    flex: 0;
    padding-top: 0;
  }
  ${(p) =>
    p.$isSelected &&
    css`
      color: ${p.theme.alphas.white50};
    `}
`;

export const StyledActionsDiv = styled.div<{$isSelected?: boolean; $hasHover: boolean}>`
  grid-area: actions;
  ${flexCenter};
  opacity: ${(p) => (p.$hasHover ? 1 : 0)};
  display: ${(p) => (p.$hasHover ? 'inherit' : 'none')};
  pointer-events: none;
  ${(p) =>
    !p.$isSelected &&
    css`
      ${directHoverSelector} {
        display: inherit;
        opacity: 1;
        pointer-events: all;
      }
    `}
`;

export const StyledActionsIcon = styled(IconButton)`
  width: 26px;
  height: 26px;
  padding: 0;
  ${center()};
`;
